var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.countNodosActivos)?_c('div',{key:"emptyContent"},[_c('MoleculeEditionAssetContentEmpty')],1):_c('div',{key:"loadedContent"},[_c('MoleculeContentNode'),_c('MoleculeEditionAssetContentComments')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }